var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "p-0" },
    _vm._l(_vm.documents, function (document) {
      return _c("li", { key: document.identifier }, [
        _c("i", {
          staticClass: "fa-solid fa-paperclip mb-2 mr-3 text-green",
          on: {
            click: function ($event) {
              return _vm.downloadFile(document)
            },
          },
        }),
        _vm._v(" "),
        _c("span", [
          _c("u", [_vm._v(_vm._s(document.name))]),
          _vm._v(" "),
          _vm.canViewAttachedDocument
            ? _c("i", {
                staticClass:
                  "fa fa-eye pl-2 cursor color-var-actionButtonColorBlue",
                on: {
                  click: function ($event) {
                    return _vm.getFile(document, "view")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("i", {
            staticClass:
              "fa fa-download px-2 cursor color-var-actionButtonColorBlue",
            on: {
              click: function ($event) {
                return _vm.getFile(document, "download")
              },
            },
          }),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }